module.exports = __webpack_public_path__ + "static/media/terms.12d37dea.md";